const API_URL = process.env.REACT_APP_API_URL;


const API_KEY = 'kmWh3MyptFBCHggy2T9KMFCaRHf8a-OehMdr6CHegYI'

exports.BASE_URL = API_URL;
exports.API_KEY = API_KEY;